import { createFileRoute, redirect } from '@tanstack/react-router';

// The framework-branded sign-up page is replaced by the ported Harborlight
// register screen. Redirect any visitor to /register.
export const Route = createFileRoute('/auth/signup')({
  beforeLoad: () => {
    throw redirect({ to: '/register' });
  }
});
